export default __webpack_public_path__ + "static/media/suggestion.6910bed8.png";